import Challenges from '@pages/challenges/Challenges';
import ChallengeGroupChallenge from '@pages/challengeGroups/challenge/ChallengeGroupChallenge';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import EditChallenge from '@pages/challengeGroups/challenges/EditChallenge';
import ChallengeScoreSummary from '@pages/challengeGroups/challenge/challengeScoreSummary/ChallengeScoreSummary';

const ChallengesRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <Challenges />
            </Route>
            <Route exact path={`${path}/:id/application-summary/:challengeid`}>
                <ChallengeScoreSummary />
            </Route>
            <Route exact path={`${path}/:id/challenges/:challengeid`}>
                <ChallengeGroupChallenge />
            </Route>
            <Route exact path={`${path}/:id/challenges/:challengeid/edit`}>
                <EditChallenge />
            </Route>
        </Switch>
    );
};

export default ChallengesRoutes;
